module.exports = __webpack_public_path__ + "img/visa.a7ce163.svg";